import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function ProgressBar({ progress, total, onCancel }) {
  const progressPercentage = parseInt(progress / total * 100, 10)

  return (
    <div className="progress-container">
      <div>
        <span className="progress-container__info u-inline-block">
          <small className="text-semibold text-dark">
            {progress}/{total} done
          </small>
          <small className="progress-container__warning text-warning u-ml10">
            <Icon type={['far', 'exclamation-circle']} />
            Do not close this window before the upload is finished!
          </small>
        </span>
        <span className="progress-container__action">
          <button
            className="btn btn-transparent btn-default btn-sm"
            onClick={() => onCancel('You are about to terminate the upload!')}
          >
            Cancel
          </button>
        </span>
      </div>
      <div>
        <span className="progress-bar--thin">
          <span className="progress-bar__progress" style={{ width: `${progressPercentage}%` }} />
          <span className="progress-bar__remainder" style={{ width: `${100 - progressPercentage}%` }} />
        </span>
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default ProgressBar
